import type { UnitText } from "@src/types/units";

/** Dropdown option label: name plus symbol, name only when symbol is missing. */
export const unitOptionLabelOf = (
  text: UnitText | null | undefined,
  fallbackId: string,
): string => {
  if (!text) return fallbackId;
  return text.symbol ? `${text.name} (${text.symbol})` : text.name;
};
